exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".distance{\r\n        margin: 12px;\r\n    }\r\n\r\n\r\n@media (max-width: 480px) {\r\n\r\n    .distance{\r\n        margin: 12px;\r\n    }\r\n}\r\n@media (min-width: 720px) {\r\n   .distance{\r\n        margin: 12px;\r\n    }\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/time/time.component.css
// module id = 656
// module chunks = 8